import Axios from "axios";
import { SET_LETTER_INFO, UNSET_LETTER_INFO } from "@/store/mutation-types";

import { saveUpdatePurLetterInfo, getPurLetterInfo } from "@/store/api";

// initial state
const state = {
    getPurLetterInfo: [],
}

const getters = {
    getPurLetterInfo(state){
        return state.getPurLetterInfo;
    }

}

const mutations = {
    [SET_LETTER_INFO](state, data) {
        state.getPurLetterInfo = data;
    },
    [UNSET_LETTER_INFO](state) {
        state.getPurLetterInfo = [];
    }
}

const actions = {
    saveUpdatePurLetterInfo({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdatePurLetterInfo, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getPurLetterInfo({ commit }) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(getPurLetterInfo)
                .then(function (response) {
                    commit(SET_LETTER_INFO, response.data);
                    resolve(response);  
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },
}


export default {
    state,
    getters,
    actions,
    mutations,
};